//imports
import { all, call, takeEvery, fork, put, select } from "@redux-saga/core/effects";
import { clientQuery } from 'Core/data/GraphQLApi';
import { ExceptionManager } from 'Core/logManager';
import { endpoints } from 'Core/defaultValues';
import moment from 'moment';
import _ from 'lodash'
import { LogManagerConsole } from 'Core/logManager';

//import { LogManager } from 'Core/logManager';

//action types
import {
  CATALOG_LOAD,
  CATALOG_INITIAL_REFRESH,
  CATALOG_SYNC_PUSH_NOTIFICATIONS,
  CATALOG_INITIAL_GET_UNIT
} from 'Redux/actionTypes';

//actions
import {
  catalogLoadResult,
  catalogLoadign,
  catalogProcessItems,
  catalogInitialRefreshResult,
  catalogProcessItem,
  catalogInitialGetUnitResult,
} from 'Redux/actions';

import { addUnits, removeUnits } from '../../realtime/redux/unitSlice';

const getCatalogs = state => state.catalogsRedux;

export function* loadCatalogs() {
  yield takeEvery(CATALOG_LOAD, function* ({ payload }) {


    try {
      const { keys, force, useGeneral } = payload; //Flag force to update elements.
      let querys = [];
      let localData = {};
      let loadings = {};
      let conditions = []
      const values = yield select(getCatalogs)
      keys.forEach((key) => {
        let tempdata = sessionStorage.getItem('catalog_' + key);
        if (tempdata) tempdata = JSON.parse(tempdata);

        let getCatalog = true;
        switch (key) {

          case 'contacts':
            loadings.loadingContacts = true;
            if (tempdata && tempdata.date && !force) {
              let date = moment(tempdata.date).add(60, 'seconds');
              if (date > moment()) {
                getCatalog = false;
              }
            }

            if (getCatalog) {
              querys.push(
                `
								contacts: searchContacts {
									id
									title
									address
									type
								}
							`);
            }
            else
              localData = { ...localData, contacts: tempdata.items };
            break;

          case 'locations':
            loadings.loadingContacts = true;
            if (tempdata && tempdata.date && !force) {
              let date = moment(tempdata.date).add(60, 'seconds');
              if (date > moment()) {
                getCatalog = false;
              }
            }

            if (getCatalog) {
              querys.push(
                `
								locations: searchLocations {
									id
									title
									active
								}
							`);
            }
            else
              localData = { ...localData, locations: tempdata.items };
            break;

          case 'timeZones':
            loadings.loadingContacts = true;
            if (tempdata && tempdata.date && !force) {
              let date = moment(tempdata.date).add(60, 'seconds');
              if (date > moment()) {
                getCatalog = false;
              }
            }

            if (getCatalog) {
              querys.push(
                `
								timeZones: searchTimeZones {
									id
									name
								}
							`);
            }
            else
              localData = { ...localData, timeZones: tempdata.items };
            break;

          case 'inputLabels':
            loadings.loadingInputLabels = true;
            if (tempdata && tempdata.date && !force) {
              let date = moment(tempdata.date).add(60, 'seconds');
              if (date > moment()) {
                getCatalog = false;
              }
            }

            if (getCatalog) {
              querys.push(
                `
								inputLabels: searchInputLabels {
									id
									title
									onLabel
									offLabel
							}
							`);
            }
            else
              localData = { ...localData, inputLabels: tempdata.items };
            break;

          case 'unitListToShow':
            loadings.loadingUnitsList = true;
            if (tempdata && tempdata.date && !force) {
              let date = moment(tempdata.date).add(60, 'seconds');
              if (date > moment()) {
                getCatalog = false;
              }
            }

            if (getCatalog) {
              querys.push(
                `
									unitListToShow: searchUnitsStatus(ignoreStatus: true) {
										id
										label
										unitVersionId
										vbus
										jbus
										useEcuOdometer
										offsetEngineOdometer
										offsetEcuEngineOdometer
										manufacturerId
										tow
										driverBehavior
										unitVersionProduct
									}
								`);
            }
            else
              localData = { ...localData, unitListToShow: tempdata.items };
            break;
          case 'maintenanceServicesItems':
            loadings.loadingMaintenanceServicesItems = true;
            if (tempdata && tempdata.date && !force) {
              let date = moment(tempdata.date).add(60, 'seconds');
              if (date > moment()) {
                getCatalog = false;
              }
            }

            if (getCatalog) {
              querys.push(
                `
									maintenanceServicesItems: searchMaintenanceServiceItems {
										id
										name
									}
								`);
            }
            else
              localData = { ...localData, maintenanceServicesItems: tempdata.items };
            break;

          case 'vehicleStatus':
            loadings.loadingMaintenanceServicesItems = true;
            if (tempdata && tempdata.date && !force) {
              let date = moment(tempdata.date).add(60, 'seconds');
              if (date > moment()) {
                getCatalog = false;
              }
            }

            if (getCatalog) {
              querys.push(
                `
								vehicleStatus: searchVehicleStatuses{
									id
									name
									iconId
									icon
									className
								}
							`);
            }
            else
              localData = { ...localData, maintenanceServicesItems: tempdata.items };
            break;

          case 'cellCarriers':
            loadings.loadingCellCarriers = true;
            if (tempdata && tempdata.date && !force) {
              let date = moment(tempdata.date).add(60, 'seconds');
              if (date > moment()) {
                getCatalog = false;
              }
            }

            if (getCatalog) {
              querys.push(
                `
								cellCarriers: searchCellCarriers {
									id
									carrier
									alias
									gateway
								}
							`);
            } else {
              localData = { ...localData, cellCarriers: tempdata.items };
            }

            break;

          case 'subusers':
            loadings.loadingSubusers = true;
            if (tempdata && tempdata.date && !force) {
              let date = moment(tempdata.date).add(60, 'seconds');
              if (date > moment()) {
                getCatalog = false;
              }
            }

            if (getCatalog) {
              querys.push(
                `
								subusers: searchSubUsers (openSearch: "", limit: 0, offset: 0) {
									items {
										id
										userName
										email
										tags {
											id
											label
										}
									}
									total
								}
							`);
            } else {
              localData = { ...localData, subusers: tempdata.items };
            }

            break;

          case 'forms':
            loadings.loadingForms = true;
            if (tempdata && tempdata.date && !force) {
              let date = moment(tempdata.date).add(60, 'seconds');
              if (date > moment()) {
                getCatalog = false;
              }
            }

            if (getCatalog) {
              querys.push(
                `
								forms: searchForms (openSearch: "", limit: 0, offset: 0) {
									items {
										id
										name
										tags {
											id
											label
										}
									}
									total
								}
							`);
            } else {
              localData = { ...localData, forms: tempdata.items };
            }

            break;


          case 'chatUsers':
            loadings.loadingChatUsers = true

            if (tempdata && tempdata.date && !force) {
              let date = moment(tempdata.date).add(60, 'seconds');
              if (date > moment()) {
                getCatalog = false;
              }
            }

            if (getCatalog) {
              querys.push(`
							chatUsers: searchContactChatUser (openSearch: "", limit: 0, offset: 0) {
									authId
									entityName
									entityId
									label
									lastConnected
									lastWriting
									avatarFileId
									avatarFile {
										id
										fileKey
										repositoryPath
									}
								}
							`)
            } else {
              localData = { ...localData, chatUsers: tempdata.items };
            }

            break;
          case 'cameras':
            loadings.loadingCameras = true
            if (tempdata && tempdata.date && !force) {
              let date = moment(tempdata.date).add(60, 'seconds');
              if (date > moment()) {
                getCatalog = false;
              }
            }

            if (getCatalog) {
              conditions = [
                {
                  "fields": ["deviceModel_manufacturer_name"],
                  "terms": ["VidFleet", "SmartWitness",],
                  "exact": true
                },
                {
                  "fields": ["linkedMode"],
                  "terms": ["1", "0"],
                  "exact": true
                }
              ]
              querys.push(`
								query searchUnits ($conditions: [UnitSearchInput]) {
									cameras: searchUnits (conditions: $conditions) {
										items {
											id
											label
											esn
											imei
											linkedMode
											linkedUnitId
											linkedUnit {
												id
												label
											}
											timeZone {
												id
												name
											}
											maintenanceWarningEventsCount
											sdCard
											isOffline
											deviceModel {
												name
												manufacturer {
													name
												}
											}
										}
										total
									}
								}
							`)
            } else {
              localData = { ...localData, cameras: tempdata.items };
            }

            break;
        }

      });

      yield put(catalogLoadign(loadings));


      let finalQuery = !useGeneral ? 'query { ' : '';
      querys.forEach((x) => {
        finalQuery += x;
      });
      finalQuery += !useGeneral ? ' }' : '';

      let data = {};
      if (querys.length > 0)
        data = yield call(clientQuery, finalQuery, conditions.length ? { conditions } : {}, useGeneral ? endpoints.GRAPHQL_GENERAL_V2 : endpoints.GRAPHQL_GENERAL);

      if (data?.chatUsers) {
        // Sort by entity type: Users (MASTERUSER + SUBUSER together), then Drivers
        // All users are sorted alphabetically as one group since they share the same "User" tag
        const users = data.chatUsers.filter(({ entityName }) => entityName === 'MASTERUSER' || entityName === 'SUBUSER')
          .sort((a, b) => a.label.localeCompare(b.label));
        const drivers = data.chatUsers.filter(({ entityName }) => entityName === 'DRIVER')
          .sort((a, b) => a.label.localeCompare(b.label));

        const sortedChatUsers = [...drivers, ...users];

        data = {
          ...data,
          chatUsers: sortedChatUsers
        }
      }

      keys.forEach((key) => {
        if (data[key])
          sessionStorage.setItem(
            'catalog_' + key,
            JSON.stringify({ date: moment(), items: data[key]?.items || data[key] }),
          );
      });

      for (let i in loadings) {
        loadings[i] = false;
      }

      let newData = {};
      for (const [key, value] of Object.entries(data)) {
        newData[key] = value?.items || value;
      }

      if (newData.driverGroups) {
        newData.driverGroups = data.driverGroups.map(x => {
          return { ...x, colorName: "#000000" }
        })
      }

      if (newData.chatUsers) {

        const chatUsers = values?.chatUsers
        newData.chatUsers = newData.chatUsers.map(x => {
          const oldItem = chatUsers.find(c => c.authId == x.authId)
          return { ...x, lastConnected: oldItem?.lastConnected, lastWriting: oldItem?.lastWriting }
        })
      }

      if (localData.chatUsers) {

        const chatUsers = values?.chatUsers
        localData.chatUsers = localData.chatUsers.map(x => {
          const oldItem = chatUsers.find(c => c.authId == x.authId)
          return { ...x, lastConnected: oldItem?.lastConnected, lastWriting: oldItem?.lastWriting }
        })
      }

      yield put(catalogLoadResult({ ...newData, ...localData, ...loadings }));
    } catch (exc) {
      // catch throw
      ExceptionManager(exc, 'Core/catalogs/redux/saga', 'loadCatalogsRequest');
      //yield put(loginResult(null, "Incorrect Username or Password"));
    }
  });
}


function* catalogInitialRefreshRequest() {
  yield takeEvery(CATALOG_INITIAL_REFRESH, function* ({ payload }) {
    const { refreshTime } = payload
    try {

      let devices = sessionStorage.getItem("unitsDiferential")
      devices = devices && JSON.parse(devices) || []
      devices = devices.filter(x => {
        let unitTime = moment(Number(x.unitTime))
        return unitTime.unix() > moment().add(-12, "hours").unix() && unitTime.unix() <= moment().add((-refreshTime), "seconds").unix()
      })
      const data = yield call(clientQuery,
        `
				query searchDifferentialReadings($devices: [DeviceLastReportInput]){
					readings: searchDifferentialReadings(devices: $devices){
						deviceId
						deviceLabel
						make
						model
						vin
						year
						unitTime
						eventCode
						eventName
						latitude
						longitude
						engineHours
						engineOdometer
						starterSupported
						starterDisabled
						dtc
						desiredStarterState
						heading
						serverTime
						address {
							address
							city
							formatted
							state
							zip
						}
						ecuEngineHours
						ecuEngineOdometer
						ecuVin
						speed
						ecuSpeed
						unitType
						landmark_id
						landmarkname
						deviceData
						temperatures
						trail{
							lat
							lon
							timestamp
						}
					}
				}
				`, { devices: devices }, endpoints.GRAPHQL_GENERAL);



      let readings = data.readings || []
      LogManagerConsole("DC_Diferencial", "catalogInitialRefreshRequest", readings.length);
      while (readings.length > 100) {
        let sendReadings = readings.slice(0, 99)
        readings = readings.slice(99, readings.length)
        LogManagerConsole("DC_Diferencial", "catalogInitialRefreshRequest", "Send", sendReadings.length);
        LogManagerConsole("DC_Diferencial_Detail", "catalogInitialRefreshRequest", "Send", sendReadings);
        yield put(catalogProcessItems("LastReading", sendReadings))
      }

      LogManagerConsole("DC_Diferencial", "catalogInitialRefreshRequest", "Send", readings.length);
      LogManagerConsole("DC_Diferencial_Detail", "catalogInitialRefreshRequest", "Send", readings);
      yield put(catalogProcessItems("LastReading", readings))
      yield put(catalogInitialRefreshResult())
    } catch (exc) {
      ExceptionManager(exc, 'Core/catalogs/redux/saga', 'catalogInitialRefreshRequest');
    }
  });
}

function* catalogSyncPushNotificationsRequest() {
  yield takeEvery(CATALOG_SYNC_PUSH_NOTIFICATIONS, function* ({ payload }) {
    const { sessionId, accountId, dateRange } = payload
    try {

      const data = yield call(clientQuery,
        `
				query searchPushNotifications ($sessionId: String, $accountId: String, $dateRange: AWSDateTimeRange, $limit: Int, $nextToken: String) {
					pushNotifications: searchPushNotifications (sessionId: $sessionId, accountId: $accountId, dateRange: $dateRange, limit: $limit, nextToken: $nextToken) {
						items {
							id
							sessionId
							accountId
							payload
							createdOn
						}
						nextToken
					}
				}
				`, {
        sessionId, accountId, dateRange, limit: 100
      }, endpoints.GRAPHQL_GENERAL);

      LogManagerConsole("DC_Diferencial", "catalogSyncPushNotificationsRequest", data);
      let pushNotifications = []

      if (data.pushNotifications)
        for (let itemString of data.pushNotifications.items) {
          let item
          try {
            //TODO: Temporal to support Reports
            item = JSON.parse(JSON.parse(itemString.payload)).message
            yield put(catalogProcessItem("Notification", item))
          } catch (e) {
            item = JSON.parse(itemString.payload)
            yield put(catalogProcessItem("Notification", item))
          }
          pushNotifications.push(item)
        }

    } catch (exc) {
      ExceptionManager(exc, 'Core/catalogs/redux/saga', 'catalogSyncPushNotificationsRequest');
    }
  });
}

export function* catalogInitialGetUnitRequest() {
  yield takeEvery(CATALOG_INITIAL_GET_UNIT, function* ({ payload }) {
    const { ids } = payload;
    try {
      let data = yield call(
        clientQuery,
        `
				query {
					units: searchUnits(ids: [${ids.join(", ")}]){
						id
						label
						esn
						imei
						driverId
						driverName
						defaultDriverId
						driverExternalId
						useEcuOdometer
						offsetEngineOdometer
						offsetEcuEngineOdometer
						useEcuEngineHours
						offsetEngineHours
						offsetEcuEngineHours
						useEcuSpeed
						jbus
						vbus
						vehicleStatusId
						deviceCategory
						unitVersionId
						unitVersionProduct
						odometerEnable
                		hoursEnable
						starter
						desiredStarterState
						timeZone {
							id
							name
						}
						typeId
						type
						supportedOutputs
						supportedInputs
						linkedUnitId
  						linkedMode
						linkedUnit {
							id
							label
							manufacturerName
							esn
							timeZone {
								id
								name
							}
							
						}
						tags {
							id
							label
							color
							parentId
							path
							hasChildren
						}
						sdCard
						maintenanceWarningEventsCount
						isOffline
						inputs {
							position
							labelId
							onLabel
							offLabel
						}
					}
				}`,
        {
          ids: ids
        },
        endpoints.GRAPHQL_GENERAL,
      );


      if (data) {
        yield put(catalogInitialGetUnitResult(false));
        const units = data.units.filter((item) => ids.includes(item.id));
        yield put(addUnits(units))

      }


    } catch (exc) {
      yield put(catalogInitialGetUnitResult(false))
      ExceptionManager(exc, 'Core/catalogs/redux/saga', 'catalogInitialGetUnitRequest');

    }
  });
}


//MERGE SAGA
export default function* rootSaga() {
  yield all([fork(loadCatalogs)]);
  yield all([fork(catalogInitialRefreshRequest)]);
  yield all([fork(catalogSyncPushNotificationsRequest)]);
  yield all([fork(catalogInitialGetUnitRequest)]);

}
